import { Phone, Trash2, Inbox } from "lucide-react";
import { leadWaLink, WhatsAppIcon } from "@/lib/whatsapp";

const STATUS = {
  nuevo: { label: "Nuevo", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  contactado: { label: "Contactado", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  cerrado: { label: "Cerrado", cls: "bg-[var(--green-50)] text-growth border-green-200" },
};

const formatDate = (iso) =>
  new Date(iso).toLocaleString("es-US", { dateStyle: "medium", timeStyle: "short" });

export const LeadsTable = ({ leads, onStatusChange, onDelete }) => {
  if (!leads.length) {
    return (
      <div className="rounded-2xl bg-white border border-dashed border-slate-300 p-14 text-center" data-testid="admin-leads-empty">
        <Inbox className="mx-auto h-10 w-10 text-slate-300" />
        <p className="mt-3 font-bold text-navy">Aún no hay leads</p>
        <p className="text-sm text-slate-500">Cuando alguien complete el formulario aparecerá aquí.</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-leads-table">
          <thead className="bg-slate-50 text-left text-xs font-bold uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-5 py-3.5">Nombre</th>
              <th className="px-5 py-3.5">Teléfono</th>
              <th className="px-5 py-3.5">Fecha</th>
              <th className="px-5 py-3.5">Bono</th>
              <th className="px-5 py-3.5">Estado</th>
              <th className="px-5 py-3.5 text-right">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {leads.map((lead, i) => (
              <tr key={lead.id} className="hover:bg-slate-50/70 transition-colors" data-testid={`lead-row-${i + 1}`}>
                <td className="px-5 py-4 font-semibold text-navy" data-testid={`lead-name-${i + 1}`}>{lead.nombre}</td>
                <td className="px-5 py-4">
                  <a href={`tel:${lead.telefono.replace(/[^\d+]/g, "")}`} className="inline-flex items-center gap-1.5 text-brand-blue font-medium hover:underline" data-testid={`lead-phone-${i + 1}`}>
                    <Phone className="h-3.5 w-3.5" /> {lead.telefono}
                  </a>
                </td>
                <td className="px-5 py-4 text-slate-600 whitespace-nowrap">{formatDate(lead.created_at)}</td>
                <td className="px-5 py-4"><span className="font-mono text-xs font-bold text-slate-600">{lead.reward_code}</span></td>
                <td className="px-5 py-4">
                  <select
                    value={lead.status}
                    onChange={(e) => onStatusChange(lead.id, e.target.value)}
                    className={`rounded-full border px-3 py-1 text-xs font-bold outline-none cursor-pointer ${STATUS[lead.status].cls}`}
                    data-testid={`lead-status-select-${i + 1}`}
                  >
                    {Object.entries(STATUS).map(([v, s]) => <option key={v} value={v}>{s.label}</option>)}
                  </select>
                </td>
                <td className="px-5 py-4 text-right">
                  <div className="inline-flex items-center gap-1.5">
                    <a
                      href={leadWaLink(lead)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 rounded-lg bg-[#25D366] hover:bg-[#1ebe5b] text-white px-3 py-1.5 text-xs font-bold transition-colors"
                      data-testid={`lead-whatsapp-button-${i + 1}`}
                    >
                      <WhatsAppIcon className="h-3.5 w-3.5" /> WhatsApp
                    </a>
                    <button
                      onClick={() => onDelete(lead.id)}
                      className="inline-flex items-center gap-1 rounded-lg px-2.5 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-50 transition-colors"
                      data-testid={`lead-delete-button-${i + 1}`}
                    >
                      <Trash2 className="h-3.5 w-3.5" /> Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
